<template>
    <div class="services-container">
        <div class="right-content">
            <div class="rule-title">{{title[key] ? title[key] : '相关协议'}}</div>
            <div class="rule-content" v-html="setting[key]"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default{
    data(){
        return{
            key: '',
            title: {
                'serviceAgreement': '服务协议',
                'userAgreement': '用户行为准则',
                'privacy': '设计师合作协议',
                'supplyAgreement': '供应商服务协议',
                'supplyPrivacy': '隐私协议(供应商)',
                'patternMakerAgreement': '版师服务协议',
                'patternMakerPrivacy': '版师隐私协议',
                'procurementAgreement': '面辅料代购服务协议',
                'procurementPrivacy': '面辅料代购隐私协议',
                'procurementAssign': '面辅料代货接单协议',
                'legal_notice': '法律声明',
                'privacy_policy': '隐私政策',
                'property_rights': '知识版权',
            },
            list:[],
            curr_index:'',
            curr_child:'',
            curr_content:{}
        }
    },
    computed:{
        ...mapState(['setting'])
    },
    async mounted(){
       this.key = this.$route.query.key
    },
    beforeRouteEnter(to,from,next){
        next((vm)=>{
            vm.$emit('changeFooter','mall');
        })
    },
    methods:{
       
    }
}
</script>
<style lang="scss" scoped>
.services-container{
    width:100%;
    height:calc(100vh - 80px);
    background:#f8f9fb;
    display:flex;
    justify-content:center;
    column-gap:20px;
    padding-top:25px;
    padding-bottom:50px;
    .left-menu{
        width:220px;
        height:100%;
        background:#fff;
        padding:0 10px;
        display:flex;
        flex-direction:column;
        overflow-x:hidden;
        .menu-title{
            width:100%;
            border-bottom:1px solid #e3e3e3;
            padding:24px 10px 16px 10px;
            font-size:20px;
            font-weight:bold;
            color:#333;
            margin-bottom:20px;
        }
        .menu-box{
            display:flex;
            flex-direction:column;
            width:100%;
            .menu-item{
                width:100%;
                height:38px;
                display:flex;
                align-items:center;
                cursor:pointer;
                padding-left:10px;
                &.active, &:hover{
                    background:#f5f5f5;
                }
                .item-icon{
                    width:16px;
                    height:16px;
                    color:#999;
                    border:1px solid #999;
                }
                .item-text{
                    font-size:16px;
                    color:#333;
                    padding-left:10px;
                }
                
            }
            .child-menu-item{
                margin-left:24px;
                margin-top:6px;
                display:flex;
                flex-direction:column;
                row-gap:10px;
                .child-item{
                    color:#666;
                    font-size:14px;
                    cursor:pointer;
                    display:flex;
                    align-items:center;
                    &.active,&:hover{
                        color:#ff5967;
                    }
                    &::before{
                        content:"●";
                        font-size:14px;
                        color:#666;
                        padding-right:10px;
                    }
                }
            }
        }
        
    }
    .right-content{
        flex:0 0 1100px;
        height:100%;
        background:#fff;
        padding:0 30px;
        display:flex;
        flex-direction:column;
        .rule-title{
            width:100%;
            text-align:center;
            border-bottom:1px solid #e3e3e3;
            padding-bottom:16px;
            padding-top:24px;
            color:#333;
            font-size:20px;
            font-weight:bold;
        }
        .rule-content{
            margin-top:24px;
            width:100%;
            flex:1;
            overflow-y:auto;
            padding-bottom:30px;
        }
    }
}
</style>